import { useState, Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import ArrowIcon from '../Icons/ArrowIcon';

export interface option {
    id?: string;
    name: string;
    code?: string;
    discount?: string | number | boolean;
}

interface SelectboxProps {
    title?: string;
    name?: string;
    value?: string;
    className?: string;
    selectOptions: option[];
    placeholder?: string;
    titleStyles?: string;
    setSelected?: React.Dispatch<React.SetStateAction<option[]>>;
    selected?: option[];
}

const MultiSelectbox = ({ title, className, selectOptions, name, value, placeholder, selected, setSelected, titleStyles }: SelectboxProps) => {
    const [selectedOptions, setSelectedOptions] = useState<option[]>(selected || []);

    const handleChange = (options: option[]) => {
        setSelectedOptions(options);
        setSelected && setSelected(options);
    };

    return (
        <Listbox name={name} value={value || selectedOptions} onChange={handleChange} multiple>
            <div className="relative w-full">
                <h1 className={`text-slate text-lg font-semibold mb-3 ${titleStyles}`}>{title}</h1>
                <Listbox.Button className={`relative text-left text-xl block w-full py-2.5 focus:outline-none hover:border-main_purple h-[50px] px-4 text-slate border-2 border-black border-opacity-40 p-4 hover:border-primary hover:border-opacity-100 transition-all ease-in focus:border-secondary focus:ring-secondary/50 rounded-lg ${className}`}>
                    <span className="block truncate text-base">{selectedOptions.length > 0 ? selectedOptions.map((option) => option.name).join(', ') : placeholder}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center pr-2">
                        <ArrowIcon className='w-6 h-4 rotate-[270deg]' />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-[9999]">
                        {selectOptions.map((option) => (
                            <Listbox.Option className='relative cursor-default select-none py-2 pl-10 pr-4' key={option.id} value={option}>
                                <span className={`block text-sm truncate`}>
                                    {option.name}
                                </span>
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    );
};

export default MultiSelectbox;
